var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"part palavra"},[_c('div',{staticClass:"enunciado",domProps:{"innerHTML":_vm._s(_vm.part.PartEnunciado)}}),_vm._v(" "),_c('div',{staticClass:"conteudo"}),_vm._v(" "),_c('answer-box',{ref:"answerbox",attrs:{"locked":_vm.locked,"part":_vm.part},on:{"respondeu":_vm.respondeu,"page-changed":_vm.pageChanged}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08560dc5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/perguntas/lacuna-palavra/PerguntaPalavra.vue
// module id = Wmqz
// module chunks = 1